import { InjectionToken } from '@angular/core';

export const ENVIRONMENT_CONFIG = new InjectionToken<any>('ENVIRONMENT_CONFIG');

export const provideEnvironmentConfig = (config: any) => ({
  provide: ENVIRONMENT_CONFIG,
  useValue: config,
});
